











import PersonTable from "@/components/person/PersonTable.vue";
import { IPerson } from "@/models/person.entity";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: { PersonTable },
  filters: {}
})
class PersonSelectionTable extends Vue {
  @Prop({ default: null })
  value!: IPerson | null;

  get selected(): IPerson[] {
    if (this.value) {
      return [this.value];
    }
    return [];
  }

  set selected(value: IPerson[]) {
    const selected = value.length > 0 ? value[0] : null;
    this.$emit("input", selected);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return this.partner.id;
  }
}

export default PersonSelectionTable;
